import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';

import { AlbumImage } from '../../models/image.album.model';
import * as albumImageActions from '../actions/image.album.actions';

export interface AlbumImageState extends EntityState<AlbumImage> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  error: AppExceptionModel | undefined;
}

export const albumImageAdapter: EntityAdapter<AlbumImage> =
  createEntityAdapter<AlbumImage>();

export const initialState: AlbumImageState = albumImageAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  error: undefined,
});

export const albumImageReducer = createReducer(
  initialState,
  on(albumImageActions.getAlbumImages, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(albumImageActions.addOneToStore, (state, { image }) =>
    albumImageAdapter.upsertOne(image, {
      ...state,
      error: undefined,
      loading: false,
      loaded: true,
    }),
  ),
  on(albumImageActions.addManyToStore, (state, { images }) => {
    return albumImageAdapter.upsertMany(images, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  on(albumImageActions.getAlbumImagesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(albumImageActions.tagUser, (state, { groupId, imageId, albumImage }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(
    albumImageActions.tagUserSuccess,
    (state, { groupId, imageId, albumImage }) =>
      albumImageAdapter.upsertOne(albumImage, {
        ...state,
        error: undefined,
        inProgress: false,
      }),
  ),
  on(albumImageActions.tagUserFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(albumImageActions.deleteImage, (state, { imageId }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(albumImageActions.deleteSuccess, (state, { groupId, imageId }) =>
    albumImageAdapter.removeOne(imageId, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(albumImageActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(albumImageActions.clearFromStore, (state, { ids }) =>
    albumImageAdapter.removeMany(ids, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(albumImageActions.clear, (state) => initialState),
);
